import { Nullable } from "../../base-types";

export interface IIterator<T = unknown> {
    current: Nullable<T>;
    canMoveNext(): boolean;
    canMovePrevious(): boolean;
    moveNextAsync(): Promise<boolean>;
    movePreviousAsync(): Promise<boolean>;
    reset(): void;
}
